var _circle, _rect, _rect2, _rect3, _rect4, _path, _circle2, _rect5, _g, _rect6, _g2, _circle3, _circle4, _circle5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgBrowserLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 43,
    r: 43,
    fill: "#FFF0F0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 22,
    width: 55.9091,
    height: 41,
    rx: 6.38961,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19.6802,
    y: 47.1539,
    width: 15.8775,
    height: 2.7375,
    rx: 1.36875,
    fill: "#FFD0D0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19.6802,
    y: 41.1313,
    width: 25.7325,
    height: 2.7375,
    rx: 1.36875,
    fill: "#FFD0D0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 19.6802,
    y: 35.6562,
    width: 35.5876,
    height: 2.7375,
    rx: 1.36875,
    fill: "#FFD0D0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 28.3896C14 24.8607 16.8607 22 20.3896 22H63.5195C67.0484 22 69.9091 24.8607 69.9091 28.3896V30.5195H14V28.3896Z",
    fill: "#FF6262"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.1442,
    cy: 49.723,
    r: 9.68673,
    fill: "#FF6262"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3500_47047",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 65,
    y: 44,
    width: 8,
    height: 8
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 69.7822,
    y: 43.9226,
    width: 4.62282,
    height: 6.75573,
    rx: 2.31141,
    transform: "rotate(45 69.7822 43.9226)",
    stroke: "black",
    strokeWidth: 1.06494
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3500_47047)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.5043 47.3831L70.5361 42.4149L66.3886 46.5625L71.3568 51.5306L75.5043 47.3831ZM71.357 51.5311L68.3997 48.5739L66.2631 50.7105L69.2204 53.6677L71.357 51.5311Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3500_47047",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 61,
    y: 47,
    width: 9,
    height: 9
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 64.7549,
    y: 55.4872,
    width: 4.62282,
    height: 6.75573,
    rx: 2.31141,
    transform: "rotate(-135 64.7549 55.4872)",
    stroke: "black",
    strokeWidth: 1.06494
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3500_47047)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.0328 52.0261L64.001 56.9943L68.1485 52.8467L63.1803 47.8786L59.0328 52.0261ZM63.1801 47.8781L66.1374 50.8353L68.274 48.6987L65.3167 45.7414L63.1801 47.8781Z",
    fill: "white"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.7753,
    cy: 26.3488,
    r: 1.6425,
    fill: "#FFF0F0"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.7026,
    cy: 26.3488,
    r: 1.6425,
    fill: "#FFF0F0"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.6303,
    cy: 26.3488,
    r: 1.6425,
    fill: "#FFF0F0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgBrowserLink);
export default __webpack_public_path__ + "static/media/img_browser_link.f0b515a7d63b04c8cda3d859f7b1b01d.svg";
export { ForwardRef as ReactComponent };